import { createFileRoute } from '@tanstack/react-router';

import { NetworksPage } from '../features/admin/networks/NetworksPage';
import { networksRouteSearchSchema } from '../features/admin/networks/networksRouteSearch';

export const Route = createFileRoute('/networks/')({
  validateSearch: networksRouteSearchSchema,
  component: NetworksPage,
});
